import React from 'react';
import TextInput from 'app/Components/Shared/TextInput/TextInput';

const TextInputWrapper = ({title, textInputObj}) => {
  return (
    <div className='text-input-wrapper'>
      <span className='text-input-title'>{title}</span>
      <TextInput  {...textInputObj} />
    </div>
  );
}
export default TextInputWrapper;
